exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".door-container{\n    background: #f0f0f0;\n    padding: 15px 25px 25px 25px;\n}\n.lfwms-btn-default{\n    margin: 0px 4px 0px 0px;\n    font-size: 13px;\n}\n.lfwms-btn-default:hover{\n    color: #ffffff;\n    background-color: #0073AB;\n}\n.door-container .message{\n    margin-bottom: 20px;\n}\n.door-container .bold{\n    font-weight: 600;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/door-schedule-popup/door-schedule-popup.component.css
// module id = ../../../../../src/app/shared/lookup/dock-door-booking-popups/door-schedule-popup/door-schedule-popup.component.css
// module chunks = main